import * as Types from '../../../data/workbench-api/generated/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type CardCancelTaskResultFragment = { __typename?: 'CardCancelTask', id: string, created: string, status: Types.CardCancelStatus, expectedCardCount?: number | null, cancelledCardCount: number, triggeredByName?: string | null, triggeredByDisplay?: string | null, clientId?: string | null, criteria: unknown, errors?: Array<string | null> | null };

export type CardCancelTasksQueryVariables = Types.Exact<{
  environmentId: Types.Scalars['String']['input'];
}>;


export type CardCancelTasksQuery = { __typename?: 'Query', cardCancelTasks?: { __typename?: 'CardCancelTasksConnection', nodes: Array<{ __typename?: 'CardCancelTask', id: string, created: string, status: Types.CardCancelStatus, expectedCardCount?: number | null, cancelledCardCount: number, triggeredByName?: string | null, triggeredByDisplay?: string | null, clientId?: string | null, criteria: unknown, errors?: Array<string | null> | null }> } | null };

export type CardCancelProgressQueryVariables = Types.Exact<{
  cancelInput?: Types.InputMaybe<Types.CardCancelProgressInput>;
}>;


export type CardCancelProgressQuery = { __typename?: 'Query', cardCancelTasksProgress: { __typename?: 'CardCancelProgressResult', organisationId: string, environmentId: string, tasks: Array<{ __typename?: 'CardCancelProgressTaskOutput', id: string, status: Types.CardCancelStatus, cancelledCardCount?: number | null, expectedCardCount?: number | null } | null> } };

export const CardCancelTaskResultFragmentDoc = gql`
    fragment CardCancelTaskResult on CardCancelTask {
  id
  created
  status
  expectedCardCount
  cancelledCardCount
  triggeredByName
  triggeredByDisplay
  clientId
  criteria
  errors
}
    `;
export const CardCancelTasksDocument = gql`
    query CardCancelTasks($environmentId: String!) {
  cardCancelTasks(
    condition: {environmentId: $environmentId}
    first: 20
    orderBy: CREATED_DESC
  ) {
    nodes {
      ...CardCancelTaskResult
    }
  }
}
    ${CardCancelTaskResultFragmentDoc}`;

/**
 * __useCardCancelTasksQuery__
 *
 * To run a query within a React component, call `useCardCancelTasksQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardCancelTasksQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardCancelTasksQuery({
 *   variables: {
 *      environmentId: // value for 'environmentId'
 *   },
 * });
 */
export function useCardCancelTasksQuery(baseOptions: Apollo.QueryHookOptions<CardCancelTasksQuery, CardCancelTasksQueryVariables> & ({ variables: CardCancelTasksQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardCancelTasksQuery, CardCancelTasksQueryVariables>(CardCancelTasksDocument, options);
      }
export function useCardCancelTasksLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardCancelTasksQuery, CardCancelTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardCancelTasksQuery, CardCancelTasksQueryVariables>(CardCancelTasksDocument, options);
        }
export function useCardCancelTasksSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CardCancelTasksQuery, CardCancelTasksQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CardCancelTasksQuery, CardCancelTasksQueryVariables>(CardCancelTasksDocument, options);
        }
export type CardCancelTasksQueryHookResult = ReturnType<typeof useCardCancelTasksQuery>;
export type CardCancelTasksLazyQueryHookResult = ReturnType<typeof useCardCancelTasksLazyQuery>;
export type CardCancelTasksSuspenseQueryHookResult = ReturnType<typeof useCardCancelTasksSuspenseQuery>;
export type CardCancelTasksQueryResult = Apollo.QueryResult<CardCancelTasksQuery, CardCancelTasksQueryVariables>;
export const CardCancelProgressDocument = gql`
    query cardCancelProgress($cancelInput: CardCancelProgressInput) {
  cardCancelTasksProgress(input: $cancelInput) {
    organisationId
    environmentId
    tasks {
      id
      status
      cancelledCardCount
      expectedCardCount
    }
  }
}
    `;

/**
 * __useCardCancelProgressQuery__
 *
 * To run a query within a React component, call `useCardCancelProgressQuery` and pass it any options that fit your needs.
 * When your component renders, `useCardCancelProgressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCardCancelProgressQuery({
 *   variables: {
 *      cancelInput: // value for 'cancelInput'
 *   },
 * });
 */
export function useCardCancelProgressQuery(baseOptions?: Apollo.QueryHookOptions<CardCancelProgressQuery, CardCancelProgressQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CardCancelProgressQuery, CardCancelProgressQueryVariables>(CardCancelProgressDocument, options);
      }
export function useCardCancelProgressLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CardCancelProgressQuery, CardCancelProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CardCancelProgressQuery, CardCancelProgressQueryVariables>(CardCancelProgressDocument, options);
        }
export function useCardCancelProgressSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<CardCancelProgressQuery, CardCancelProgressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<CardCancelProgressQuery, CardCancelProgressQueryVariables>(CardCancelProgressDocument, options);
        }
export type CardCancelProgressQueryHookResult = ReturnType<typeof useCardCancelProgressQuery>;
export type CardCancelProgressLazyQueryHookResult = ReturnType<typeof useCardCancelProgressLazyQuery>;
export type CardCancelProgressSuspenseQueryHookResult = ReturnType<typeof useCardCancelProgressSuspenseQuery>;
export type CardCancelProgressQueryResult = Apollo.QueryResult<CardCancelProgressQuery, CardCancelProgressQueryVariables>;